module.exports = __webpack_public_path__ + "static/media/mode-52.3a4b1084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-52.svg
// module id = 1024
// module chunks = 2